import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Col, Container, Image, Row } from "react-bootstrap";

import i18n from "../../i18n";

const BottleCycleScreen: React.FC = () => {
  const { t, language } = i18n;

  return (
    <Container
      fluid
      className="screenContainer infoDarkContainer"
      style={{ minHeight: "50vh" }}
    >
      <Container className="flexContainer pakvertContainer">
        <Row className="gx-5">
          <Col lg={7} xs={12}>
            <div className="flexContainer" style={{ gap: "8px" }}>
              <h2>{t("_technology_screen.3.title")}</h2>
              <p>{t("_technology_screen.3.description")}</p>
            </div>
          </Col>

          <Col lg={5} xs={12}>
            <div
              className="flexContainer mt-4 mt-lg-0"
              style={{ alignItems: "center" }}
            >
              <AnimationOnScroll
                animateOnce
                animateIn="animate__fadeInRightBig"
              >
                <Image
                  rounded
                  alt={t("_technology_screen.3.title")}
                  className="technologyBottleCycle"
                  src={`/images/technology/Bottle_Cycle_${language}.png`}
                />
              </AnimationOnScroll>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default BottleCycleScreen;
